
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4iTbK", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $9hBBk = parcelRequire("9hBBk");


var $7JKd3 = parcelRequire("7JKd3");

function $c818d579c2a95bd2$export$d2a66369b43f5d65({ selectedText: selectedText, onClose: onClose, onOptionSelect: onOptionSelect, onRemixFlowActiveChange: onRemixFlowActiveChange, isEphemeralViewVisible: isEphemeralViewVisible = false }) {
    const [isThinking, setIsThinking] = (0, $42omo.useState)(false);
    const handleOptionSelect = (0, $42omo.useCallback)((params)=>{
        setIsThinking(true);
        onRemixFlowActiveChange?.(true);
        onOptionSelect?.(params);
    }, [
        onOptionSelect,
        onRemixFlowActiveChange
    ]);
    const handleStopThinking = (0, $42omo.useCallback)(()=>{
        setIsThinking(false);
        onRemixFlowActiveChange?.(false);
    }, [
        onRemixFlowActiveChange
    ]);
    // While thinking: show thinking bar only when ephemeral is not yet visible; otherwise show nothing
    if (isThinking) {
        if (!isEphemeralViewVisible) return /*#__PURE__*/ (0, $l998X.jsx)((0, $7JKd3.RemixThinkingBar), {
            onStop: handleStopThinking
        });
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {});
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9hBBk.RemixOverlay), {
        selectedText: selectedText,
        onClose: onClose,
        onOptionSelect: handleOptionSelect
    });
}
module.exports["RemixContainer"] = $c818d579c2a95bd2$export$d2a66369b43f5d65;

});

parcelRegister("9hBBk", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $1qfLF = parcelRequire("1qfLF");


var $euUgw = parcelRequire("euUgw");


var $gj7hi = parcelRequire("gj7hi");


var $5nBzc = parcelRequire("5nBzc");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $fVUfS = parcelRequire("fVUfS");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $4noo5 = parcelRequire("4noo5");


var $3gadb = parcelRequire("3gadb");


var $eXcS3 = parcelRequire("eXcS3");


var $3GvsX = parcelRequire("3GvsX");


var $KX93L = parcelRequire("KX93L");


var $j0i6b = parcelRequire("j0i6b");


var $ldlmH = parcelRequire("ldlmH");


var $ljWwX = parcelRequire("ljWwX");


var $k9bra = parcelRequire("k9bra");


var $g9DlN = parcelRequire("g9DlN");


var $aHyhl = parcelRequire("aHyhl");


var $eaTkV = parcelRequire("eaTkV");

const $adb20307aac79bd1$var$messages = (0, $cgtv4.defineMessages)({
    heading: {
        id: "malleable-ui-components.remix.heading",
        defaultMessage: "Remix"
    },
    subtitle: {
        id: "malleable-ui-components.remix.subtitle",
        defaultMessage: "Visualize this content in a new way"
    },
    labsLozenge: {
        id: "malleable-ui-components.remix.labs-lozenge",
        defaultMessage: "LABS"
    },
    selectedContent: {
        id: "malleable-ui-components.remix.selected-content",
        defaultMessage: "Selected content"
    },
    noContent: {
        id: "malleable-ui-components.remix.no-content",
        defaultMessage: "No content selected"
    },
    remixOptionChart: {
        id: "malleable-ui-components.remix.option.chart",
        defaultMessage: "Chart"
    },
    remixOptionDiagram: {
        id: "malleable-ui-components.remix.option.diagram",
        defaultMessage: "Diagram"
    },
    remixOptionInfographic: {
        id: "malleable-ui-components.remix.option.infographic",
        defaultMessage: "Infographic"
    },
    remixOptionVisual: {
        id: "malleable-ui-components.remix.option.visual",
        defaultMessage: "Visual"
    },
    describePlaceholder: {
        id: "malleable-ui-components.remix.describe-placeholder",
        defaultMessage: "Or describe your remix..."
    },
    describeSubmitLabel: {
        id: "malleable-ui-components.remix.describe-submit-label",
        defaultMessage: "Submit"
    },
    remixIconAlt: {
        id: "malleable-ui-components.remix.icon-alt",
        defaultMessage: "Remix icon"
    },
    remixArrowsIconAlt: {
        id: "malleable-ui-components.remix.arrows-icon-alt",
        defaultMessage: "Remix arrows"
    },
    chartIconAlt: {
        id: "malleable-ui-components.remix.option.chart-icon-alt",
        defaultMessage: "Chart icon"
    },
    diagramIconAlt: {
        id: "malleable-ui-components.remix.option.diagram-icon-alt",
        defaultMessage: "Diagram icon"
    },
    infographicIconAlt: {
        id: "malleable-ui-components.remix.option.infographic-icon-alt",
        defaultMessage: "Infographic icon"
    },
    visualIconAlt: {
        id: "malleable-ui-components.remix.option.visual-icon-alt",
        defaultMessage: "Visual icon"
    },
    chartTooltip: {
        id: "malleable-ui-components.remix.option.chart-tooltip",
        defaultMessage: "View your data as a chart or graph"
    },
    diagramTooltip: {
        id: "malleable-ui-components.remix.option.diagram-tooltip",
        defaultMessage: "Show relationships with a diagram"
    },
    infographicTooltip: {
        id: "malleable-ui-components.remix.option.infographic-tooltip",
        defaultMessage: "Summarize key points with an infographic"
    },
    visualTooltip: {
        id: "malleable-ui-components.remix.option.visual-tooltip",
        defaultMessage: "Bring your content to life with a bespoke visual"
    },
    labsLozengeTooltip: {
        id: "malleable-ui-components.remix.option.lozenge-tooltip",
        defaultMessage: "Beta: This feature is still in development."
    }
});
const $adb20307aac79bd1$var$ROVO_GRADIENT_BACKGROUND = `conic-gradient(
  from var(--gradient-angle, 45deg),
  #FCA700 10%,
  #6A9A23 30%,
  #6A9A23 50%,
  #1868DB 70%,
  #AF59E0 90%
)`;
const $adb20307aac79bd1$var$rovoGradientRotation = null;
const $adb20307aac79bd1$var$rovoGradientVisualStyle = null;
const $adb20307aac79bd1$var$rovoGradientContainerStyle = null;
const $adb20307aac79bd1$var$rovoGradientInnerStyle = null;
const $adb20307aac79bd1$var$modalContentWrapperStyle = null;
const $adb20307aac79bd1$var$remixStyles = {
    headerRow: "_1bsb1osq",
    labsRow: "_1bsb1osq _80om73ad",
    remixIconWrapper: "_kqswh2mm _1bsbvbgk _4t3ivbgk",
    remixArrowsLayer: "_1r04idpf _kqswstnw _1e0c1txw _4cvr1h6o _1bah1h6o",
    subtitle: "_syaz1rpy _1pfh1b66",
    describeInputBorderWrapper: "_1bsb1osq _1pfhpxbi _uwhke4h9 _15a5nqa1 _1i531l7x",
    describeInputWrapper: "_zulpu2gc _1rjcutpp _1bsb1osq _4cvr1h6o _bfhkhfxm",
    modalBodyPadding: "_18zrpxbi _1q511b66",
    remixOptionsStack: "_1bsb1osq",
    remixOptionPressable: "_2rko1qi0 _189ee4h9 _1dqonqa1 _1h6d1l7x _1rjcutpp _18zru2gc _1bsb1osq _4t3ickbl _1e0c1txw _4cvr1h6o _bfhk1bhr _irr31dpa _1di6fcek",
    remixOptionIconContainer: "_2rkol0p1 _1rjc12x7 _18zr12x7 _1e0c116y _4cvr1h6o _1bah1h6o _bfhkhfxm"
};
const $adb20307aac79bd1$var$remixIconLayerStyle = null;
const $adb20307aac79bd1$var$remixArrowsImgStyle = null;
const $adb20307aac79bd1$var$RemixOptionIcon = ({ src: src, srcDark: srcDark, alt: alt })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        as: "span",
        xcss: $adb20307aac79bd1$var$remixStyles.remixOptionIconContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
            src: src,
            srcDark: srcDark,
            alt: alt
        })
    });
const $adb20307aac79bd1$var$REMIX_OPTIONS = [
    {
        type: 'chart',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ldlmH))),
        iconDark: (0, (/*@__PURE__*/$parcel$interopDefault($eXcS3))),
        labelMessage: $adb20307aac79bd1$var$messages.remixOptionChart,
        iconAltMessage: $adb20307aac79bd1$var$messages.chartIconAlt,
        tooltipMessage: $adb20307aac79bd1$var$messages.chartTooltip,
        testId: 'remix-overlay-option-chart'
    },
    {
        type: 'diagram',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ljWwX))),
        iconDark: (0, (/*@__PURE__*/$parcel$interopDefault($3GvsX))),
        labelMessage: $adb20307aac79bd1$var$messages.remixOptionDiagram,
        iconAltMessage: $adb20307aac79bd1$var$messages.diagramIconAlt,
        tooltipMessage: $adb20307aac79bd1$var$messages.diagramTooltip,
        testId: 'remix-overlay-option-diagram'
    },
    {
        type: 'infographic',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($k9bra))),
        iconDark: (0, (/*@__PURE__*/$parcel$interopDefault($KX93L))),
        labelMessage: $adb20307aac79bd1$var$messages.remixOptionInfographic,
        iconAltMessage: $adb20307aac79bd1$var$messages.infographicIconAlt,
        tooltipMessage: $adb20307aac79bd1$var$messages.infographicTooltip,
        testId: 'remix-overlay-option-infographic'
    },
    {
        type: 'visual-aid',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($g9DlN))),
        iconDark: (0, (/*@__PURE__*/$parcel$interopDefault($j0i6b))),
        labelMessage: $adb20307aac79bd1$var$messages.remixOptionVisual,
        iconAltMessage: $adb20307aac79bd1$var$messages.visualIconAlt,
        tooltipMessage: $adb20307aac79bd1$var$messages.visualTooltip,
        testId: 'remix-overlay-option-visual-aid'
    }
]; /**
     * Props for the Remix overlay modal.
     */ 
function $adb20307aac79bd1$export$48a746fedb7ffb({ selectedText: // eslint-disable-next-line @typescript-eslint/no-unused-vars -- will be used in a follow-up implementation
selectedText, onClose: onClose, onOptionSelect: onOptionSelect }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [describeValue, setDescribeValue] = (0, $42omo.useState)('');
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8CZUH.default), {
            onClose: onClose,
            width: 300,
            height: 444,
            testId: "remix-overlay",
            children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                "data-testid": "remix-overlay-gradient-border",
                className: (0, $gMc0m.default)([
                    "_16jlkb7n _1o9zkb7n _i0dl1wug _11q77nzb _y44v117x _2rko1kw7 _1bsb1osq _1e0c1txw _2lx21bp4"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $gMc0m.default)([
                        "_16jlkb7n _1o9zkb7n _i0dl1wug _1reoewfl _18m9ewfl _2rko1kw7 _1bsb1osq _kqswh2mm _1e0c1txw _2lx21bp4"
                    ]),
                    children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            "_2rko1kw7 _16jlkb7n _1o9zkb7n _i0dl1wug _1rjcv77o _18zrv77o _bfhkhfxm _1y1m1ntv _1e0c1txw _2lx21bp4"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                            className: (0, $gMc0m.default)([
                                "_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _2rko1kw7 _1e0c1txw _2lx21bp4 _bfhkhfxm"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                                    hasCloseButton: false,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                        xcss: $adb20307aac79bd1$var$remixStyles.headerRow,
                                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                                            space: "space.200",
                                            alignInline: "center",
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                                                    content: formatMessage($adb20307aac79bd1$var$messages.labsLozengeTooltip),
                                                    position: "right",
                                                    children: (tooltipProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                                                            ...tooltipProps,
                                                            justifyContent: "end",
                                                            xcss: $adb20307aac79bd1$var$remixStyles.labsRow,
                                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                                                                appearance: "new",
                                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                                    ...$adb20307aac79bd1$var$messages.labsLozenge
                                                                })
                                                            })
                                                        })
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                                                    xcss: $adb20307aac79bd1$var$remixStyles.remixIconWrapper,
                                                    "aria-hidden": true,
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($eaTkV))),
                                                            alt: formatMessage($adb20307aac79bd1$var$messages.remixIconAlt),
                                                            className: (0, $gMc0m.default)([
                                                                "_1r04idpf _kqswstnw _1bsb1osq _4t3i1osq _5ral1dfr"
                                                            ])
                                                        }),
                                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                            xcss: $adb20307aac79bd1$var$remixStyles.remixArrowsLayer,
                                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($aHyhl))),
                                                                alt: formatMessage($adb20307aac79bd1$var$messages.remixArrowsIconAlt),
                                                                className: (0, $gMc0m.default)([
                                                                    "_1bsb1f4h _4t3i1f4h _5ral1f51"
                                                                ])
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                                                    space: "space.050",
                                                    alignInline: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                                ...$adb20307aac79bd1$var$messages.heading
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                            xcss: $adb20307aac79bd1$var$remixStyles.subtitle,
                                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                                size: "small",
                                                                color: "color.text.subtle",
                                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                                    ...$adb20307aac79bd1$var$messages.subtitle
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1DHa6.default), {
                                    hasInlinePadding: false,
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                            xcss: $adb20307aac79bd1$var$remixStyles.modalBodyPadding,
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                                                space: "space.100",
                                                alignInline: "stretch",
                                                xcss: $adb20307aac79bd1$var$remixStyles.remixOptionsStack,
                                                children: $adb20307aac79bd1$var$REMIX_OPTIONS.map((option)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                                                        content: formatMessage(option.tooltipMessage),
                                                        position: "right",
                                                        children: (tooltipProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                                                                ...tooltipProps,
                                                                xcss: $adb20307aac79bd1$var$remixStyles.remixOptionPressable,
                                                                onClick: ()=>onOptionSelect?.({
                                                                        type: option.type
                                                                    }),
                                                                testId: option.testId,
                                                                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                                                                    alignItems: "center",
                                                                    gap: "space.100",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $l998X.jsx)($adb20307aac79bd1$var$RemixOptionIcon, {
                                                                            src: option.icon,
                                                                            srcDark: option.iconDark,
                                                                            alt: formatMessage(option.iconAltMessage)
                                                                        }),
                                                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                                                            children: formatMessage(option.labelMessage)
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                    }, option.type))
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                            xcss: $adb20307aac79bd1$var$remixStyles.describeInputBorderWrapper,
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                xcss: $adb20307aac79bd1$var$remixStyles.modalBodyPadding,
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                                                    xcss: $adb20307aac79bd1$var$remixStyles.describeInputWrapper,
                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default), {
                                                        appearance: "none",
                                                        placeholder: formatMessage($adb20307aac79bd1$var$messages.describePlaceholder),
                                                        value: describeValue,
                                                        onChange: (e)=>setDescribeValue(e.currentTarget.value),
                                                        isCompact: true,
                                                        "aria-label": formatMessage($adb20307aac79bd1$var$messages.describePlaceholder),
                                                        testId: "remix-overlay-describe-input",
                                                        elemAfterInput: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                                            appearance: "primary",
                                                            shape: "circle",
                                                            isDisabled: !describeValue?.trim(),
                                                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($euUgw))),
                                                            label: formatMessage($adb20307aac79bd1$var$messages.describeSubmitLabel),
                                                            onClick: ()=>onOptionSelect?.({
                                                                    type: 'custom',
                                                                    userPrompt: describeValue
                                                                }),
                                                            testId: "remix-overlay-describe-submit"
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
}
module.exports["RemixOverlay"] = $adb20307aac79bd1$export$48a746fedb7ffb;

});

parcelRegister("eXcS3", function(module, exports) {
module.exports = new URL("chart-icon-dark.ca77575e.svg", import.meta.url).toString();

});

parcelRegister("3GvsX", function(module, exports) {
module.exports = new URL("diagram-icon-dark.3f4564aa.svg", import.meta.url).toString();

});

parcelRegister("KX93L", function(module, exports) {
module.exports = new URL("infographic-dark.f9711bcb.svg", import.meta.url).toString();

});

parcelRegister("j0i6b", function(module, exports) {
module.exports = new URL("visual-aid-dark.4d0ae5ae.svg", import.meta.url).toString();

});

parcelRegister("ldlmH", function(module, exports) {
module.exports = new URL("chart-icon.a14be180.svg", import.meta.url).toString();

});

parcelRegister("ljWwX", function(module, exports) {
module.exports = new URL("diagram-icon.695c35c3.svg", import.meta.url).toString();

});

parcelRegister("k9bra", function(module, exports) {
module.exports = new URL("infographic-light.59c85d21.svg", import.meta.url).toString();

});

parcelRegister("g9DlN", function(module, exports) {
module.exports = new URL("visual-aid.4cbe3ad7.svg", import.meta.url).toString();

});

parcelRegister("aHyhl", function(module, exports) {
module.exports = new URL("remix-arrows.200b20a4.svg", import.meta.url).toString();

});

parcelRegister("eaTkV", function(module, exports) {
module.exports = new URL("remix-gradient.1d889e99.svg", import.meta.url).toString();

});

parcelRegister("7JKd3", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $1qfLF = parcelRequire("1qfLF");


var $5lVpa = parcelRequire("5lVpa");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $6UNNU = parcelRequire("6UNNU");

const $80dee16929296708$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "malleable-ui-components.remix-thinking-bar.title",
        defaultMessage: "Rovo is building your visual aid"
    },
    escHint: {
        id: "malleable-ui-components.remix-thinking-bar.esc-hint",
        defaultMessage: "Esc"
    },
    stopLabel: {
        id: "malleable-ui-components.remix-thinking-bar.stop-label",
        defaultMessage: "Stop remixing"
    }
});
const $80dee16929296708$var$styles = {
    fixedWrapper: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _2rko1tm3 _zulpu2gc _18zrpxbi _1rjcu2gc _kqsw1n9t _94n5pxbi _1ltv1b66 _1xi21b66 _1bsb1ns9 _1pbyni7l _bfhk1bhr _16qs130s _1e0c1txw _4cvr1h6o _1bah1yb4 _1ul91mjv",
    escBadge: "_2rko12b0 _11c8wadc _18zr1b66 _1rjcv77o _bfhkysee _syaz1rpy"
};
function $80dee16929296708$export$d6f2d83daf5efc44({ onStop: onStop, title: title }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        as: "div",
        xcss: $80dee16929296708$var$styles.fixedWrapper,
        testId: "remix-thinking-bar",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6UNNU.RovoThinkingIndicator), {
                title: title || formatMessage($80dee16929296708$var$messages.title)
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                alignBlock: "center",
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        as: "span",
                        xcss: $80dee16929296708$var$styles.escBadge,
                        children: formatMessage($80dee16929296708$var$messages.escHint)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        shape: "circle",
                        onClick: onStop,
                        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5lVpa))), {
                                ...iconProps,
                                color: "var(--ds-icon-danger, #C9372C)",
                                label: ""
                            }),
                        label: formatMessage($80dee16929296708$var$messages.stopLabel)
                    })
                ]
            })
        ]
    });
}
module.exports["RemixThinkingBar"] = $80dee16929296708$export$d6f2d83daf5efc44;

});

parcelRegister("1ITQ3", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $a4TK8 = parcelRequire("a4TK8");


var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $7Ndnw = parcelRequire("7Ndnw");


var $3b6WO = parcelRequire("3b6WO");

const $336551b5acc450de$var$DEFAULT_EXTENSION_VIEWPORT_SIZES = [];
const $336551b5acc450de$export$e863f5b50b03c8cc = (skipQuery = false)=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const VIEWPORT_SIZE_KEY = `${(0, $7Ndnw.FORGE_MODULE_XEN_MACRO)}:viewportSizes:${contentId}`;
    const filteredExtensions = window.__SSR_FORGE_EXTENSIONS__?.[VIEWPORT_SIZE_KEY]?.extensions ?? $336551b5acc450de$var$DEFAULT_EXTENSION_VIEWPORT_SIZES;
    // Technically here cached value can have length of 0.
    // In this case, we don't want to skip the query as we have no way to tell whether its from cache or just default value.
    const hasCachedValue = filteredExtensions.length > 0;
    const { extensions: extensions, loading: loading, error: error } = (0, $3b6WO.useExtensionList)({
        moduleType: (0, $7Ndnw.FORGE_MODULE_XEN_MACRO),
        skipQuery: skipQuery || hasCachedValue
    });
    const prevExtensionViewportSizes = (0, $42omo.useRef)(filteredExtensions);
    if (loading || error || !extensions) return filteredExtensions;
    const nextExtensionViewportSizes = extensions.map(({ id: id, properties: properties })=>properties?.viewportSize ? {
            extensionId: id,
            viewportSize: properties.viewportSize
        } : undefined).filter(Boolean);
    if (prevExtensionViewportSizes.current.length !== nextExtensionViewportSizes.length || !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(prevExtensionViewportSizes.current, nextExtensionViewportSizes)) {
        prevExtensionViewportSizes.current = nextExtensionViewportSizes;
        // Write to window object to cache the viewport sizes.
        if (window.__SSR_FORGE_EXTENSIONS__) window.__SSR_FORGE_EXTENSIONS__ = {
            ...window.__SSR_FORGE_EXTENSIONS__,
            [VIEWPORT_SIZE_KEY]: {
                extensions: nextExtensionViewportSizes
            }
        };
    }
    return prevExtensionViewportSizes.current;
};
module.exports["useExtensionViewportSizes"] = $336551b5acc450de$export$e863f5b50b03c8cc;

});

parcelRegister("7eOZ4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kyKWe = parcelRequire("kyKWe");


var $2O3ot = parcelRequire("2O3ot");


var $bPHr8 = parcelRequire("bPHr8");


var $aouqA = parcelRequire("aouqA");


var $3jwuS = parcelRequire("3jwuS");


var $jyA9t = parcelRequire("jyA9t");


var $ep3mz = parcelRequire("ep3mz");


var $9wGTI = parcelRequire("9wGTI");

const $1e31de274ed01603$export$cca9e2432f59b3f8 = ()=>{
    const { sendMessage: sendMessage, createConversationOptimistically: createConversationOptimistically, abortRequests: abortRequests, activeConversation: activeConversation } = (0, $aouqA.useSmartCreationChatStoreApi)();
    const { setPrompt: setPrompt, setDynamicUiContext: setDynamicUiContext } = (0, $2O3ot.useStagingAreaActions)();
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isRovoResponding = activeConversation?.status === (0, $bPHr8.CHAT_STORE_STATUS).typingResponse;
    const stopRemixing = (0, $42omo.useCallback)(()=>{
        abortRequests?.({
            conversationId: activeConversation?.id
        });
    }, [
        abortRequests,
        activeConversation?.id
    ]);
    const openAIFCStagingModal = (0, $42omo.useCallback)(()=>{
        // Open the Confluence Smart Creation Modal with stagingAreaActive=true
        // to skip the prompt screen and go straight to the staging area preview.
        // A no-op submitCallback is passed so that handleSubmit in ConfluenceSmartCreationModal
        // invokes this callback instead of navigating away from the current page.
        openModal({
            entryPoint: 'dynamicUi',
            spaceKey: spaceKey ?? undefined,
            stagingAreaActive: true,
            isFloating: true,
            shouldShowBackButton: false,
            content: contentId ? {
                id: contentId,
                type: contentType ?? 'page',
                subType: isLivePage ? 'live' : null
            } : undefined,
            submitCallback: async ()=>{}
        });
    }, [
        openModal,
        spaceKey,
        contentId,
        contentType,
        isLivePage
    ]);
    const sendAIFCPrompt = (0, $42omo.useCallback)(async ({ userPrompt: userPrompt, dynamicUiType: dynamicUiType, dynamicUiSource: dynamicUiSource })=>{
        const promptText = userPrompt !== undefined ? userPrompt : 'Remix the selected content';
        // Build the ADF DocNode prompt
        const prompt = {
            type: 'doc',
            version: 1,
            content: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: promptText
                        }
                    ]
                }
            ]
        };
        const newConversationId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        await createConversationOptimistically({
            id: newConversationId
        });
        // Send the message to Rovo
        sendMessage({
            prompt: prompt,
            storeUserMessages: false,
            conversationId: newConversationId,
            messageSources: {
                interactionSource: 'smartCreate'
            },
            productKey: 'confluence',
            contentContext: 'staging-area',
            // Only send minionAlias if the feature gate is not enabled
            ...(0, $9wGTI.fg)('confluence_disable_remix_minion_alias') ? {} : {
                minionAlias: 'remix-content'
            },
            creationContextParams: {
                dynamicUiType: dynamicUiType,
                dynamicUiSource: dynamicUiSource
            }
        });
        // Store the prompt text for display in the staging area header
        setPrompt(promptText);
        // Persist the dynamic UI context so the update flow can use
        // the original type/source when sending remix adjustment messages
        setDynamicUiContext(dynamicUiType, dynamicUiSource);
    }, [
        createConversationOptimistically,
        sendMessage,
        setPrompt,
        setDynamicUiContext
    ]);
    return {
        sendAIFCPrompt: sendAIFCPrompt,
        stopRemixing: stopRemixing,
        isRovoResponding: isRovoResponding,
        openAIFCStagingModal: openAIFCStagingModal
    };
};
module.exports["useRemixToAIFC"] = $1e31de274ed01603$export$cca9e2432f59b3f8;

});


//# sourceMappingURL=PageContentRendererFabric.060d2b5c.js.map
